//This controller is used for managing api calls of whole project
/**
 * apiManager.js
 * copyright © 2022 Ania Management
 */
import Axios from "axios";

const newBackendBaseUrl =
  process.env.REACT_APP_NEW_BACKEND_URL ||
  "https://pgbackend.aniamanagement.com/api/v1/";

export const apiCall = async (method, url, body, params) => {
  try {
    const {
      data: { data },
    } = await Axios({
      method: method,
      url: `${newBackendBaseUrl}${url}`,
      data: body,
      params: params,
    });

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * For endpoints migrated to the new backend (Tier 5A onwards).
 * Returns the same `response.data.data` shape as the legacy `apiCall` so
 * callers don't need to change.
 */
export const apiCallNewBackend = async (method, url, body, params) => {
  try {
    const {
      data: { data },
    } = await Axios({
      method: method,
      url: `${newBackendBaseUrl}${url}`,
      data: body,
      params: params,
    });

    return data;
  } catch (err) {
    throw err;
  }
};
